module.exports = __webpack_public_path__ + "img/Certificate.2ef32aae.jpg";